/*
 *
 * Scanner constants
 *
 */

export const CONNECT_TO_SERVICE = 'claris-vnext/Scanner/CONNECT_TO_SERVICE';
export const DISCONNECT_FROM_SERVICE = 'claris-vnext/Scanner/DISCONNECT_FROM_SERVICE';
export const SCAN_PASSPORT = 'claris-vnext/Scanner/SCAN_PASSPORT';
